import React from 'react';
import { Link } from '../../../env';
const Footer = () => {
    const menu = [
        {
            name: 'Home',
            href: '/#home',
            img: `${Link}/assets/Icons/home.png`,
        },
        {
            name: 'Tutorials',
            href: '/#tutorial',
            img: `${Link}/assets/Icons/tutorial.png`,
        },
        {
            name: 'Downloads',
            href: '/#download',
            img: `${Link}/assets/Icons/download.png`,
        },
        {
            name: 'Contact us',
            href: '/#contactus',
            img: `${Link}/assets/Icons/tutorial.png`,
        },
        {
            name: 'Signin',
            href: '/#signin',
            img: `${Link}/assets/Icons/login-.png`,
        },
        {
            name: 'Signup',
            href: '/#signup',
            img: `${Link}/assets/Icons/register.png`,
        }
    ]
    return (
        <div className='w-full mt-20 h-[400px] bg-[rgba(33,47,60,0.9)] flex justify-center'>
            <div className='container flex h-full'>
                <div className='w-[20%] h-full'>
                    <ul className='w-full h-full flex flex-col border-l-[1px] border-r-[1px] border-[rgba(255,255,255,0.2)]'>
                        {
                            menu.map((item, index) => (
                                <a className={`w-full flex-1 bg-[rgba(33,47,60,0.9)] cursor-pointer hover:bg-[rgba(33,47,60,0.2)] ${(index < menu.length - 1) ? 'border-b-[1px] border-[rgba(255,255,255,0.2)]' : ''} flex items-center`} key={index} href={item.href}>
                                    <li className='w-full poppins-regular text-base text-white px-5 flex items-center'>
                                        <span><img src={item.img} alt="Home" /></span>
                                        <span className='mx-6'>{item.name}</span>
                                    </li>
                                </a>
                            ))
                        }
                    </ul>
                </div>
                <div className='w-[80%] h-full px-5'>
                    <div className='w-full flex space-x-5 mt-5'>
                        <div className='w-1/2 h-[70px] p-2'>
                            <div className='w-full h-full flex rounded-md Box-Shadow'>
                                <div className='w-[20%] h-full flex items-center justify-center'>
                                    <img src={`${Link}/assets/Icons/user-icon.png`} alt='usericon' className='w-[25%] xl:w-[25%] 2xl:w-[25%]' />
                                </div>
                                <div className='w-[80%] h-full flex items-center justify-center'>
                                    <input type='text' className='w-full h-full flex bg-transparent text-white px-2 focus:outline-none poppins-regular' placeholder='Enter Full Name ...' />
                                </div>
                            </div>
                        </div>
                        <div className='w-1/2 h-[70px] p-2'>
                            <div className='w-full h-full flex rounded-md Box-Shadow'>
                                <div className='w-[20%] h-full flex items-center justify-center'>
                                    <img src={`${Link}/assets/Icons/eaddress.png`} alt='usericon' className='w-[25%] xl:w-[25%] 2xl:w-[25%]' />
                                </div>
                                <div className='w-[80%] h-full flex items-center justify-center'>
                                    <input type='text' className='w-full h-full flex bg-transparent text-white px-2 focus:outline-none poppins-regular' placeholder='Enter email address ...' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='w-full'>
                        <div className='w-full h-[200px] p-2'>
                            <textarea placeholder='Write Your Message . . .' className='w-full h-full resize-none poppins-regular bg-transparent rounded-md Box-Shadow focus:outline-none text-white p-5'></textarea>
                        </div>
                    </div>
                    <div className='w-full p-2 flex justify-center items-center'>
                        <div className='w-full flex justify-center items-center'>
                            <button className='w-[50%] hover:bg-[#34495e] hover:border-[1px] hover:border-[rgba(255,255,255,0.4)] poppins-regular mt-2 items-center text-white text-center rounded-md h-[50px] bg-[#1f618d]'>
                                Send Message . . .
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;